module.exports = __webpack_public_path__ + "static/ui-2-80627333160be82fcab7dc9857c06836.png";